import { render, staticRenderFns } from "./CardManipulated.vue?vue&type=template&id=54b869a4"
import script from "./CardManipulated.vue?vue&type=script&lang=js"
export * from "./CardManipulated.vue?vue&type=script&lang=js"
import style0 from "./CardManipulated.vue?vue&type=style&index=0&id=54b869a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports